module.exports = __webpack_public_path__ + "static/media/originEnergy.1986e697.png";